/**
 * Functionality for loading more posts in archives
 * Native JS only - no jQuery
 */
function vzAjaxLoadMore() {
  const loadMoreButton = document.getElementById('load-more-button');
  if (!loadMoreButton) return;

  const mainContainer = document.querySelector('main[role="main"]');
  if (!mainContainer) return;

  const contentType = mainContainer.dataset.contentType;
  const contentId = parseInt(mainContainer.dataset.contentId);
  const maxPages = parseInt(mainContainer.dataset.maxNumPages);

  let loadMoreButtonLabel = loadMoreButton.querySelector('.load-more-button__label');
  let loadMoreButtonLoader = loadMoreButton.querySelector('.loader');

  if (!loadMoreButtonLabel) {
    loadMoreButtonLabel = document.createElement('span');
    loadMoreButtonLabel.className = 'load-more-button__label';

    while (loadMoreButton.firstChild) {
      loadMoreButtonLabel.appendChild(loadMoreButton.firstChild);
    }

    loadMoreButton.appendChild(loadMoreButtonLabel);
  }

  if (!loadMoreButtonLoader) {
    loadMoreButtonLoader = document.createElement('span');
    loadMoreButtonLoader.className = 'loader';
    loadMoreButtonLoader.setAttribute('aria-hidden', 'true');
    loadMoreButton.appendChild(loadMoreButtonLoader);
  }

  let isLoading = false;
  let currentPage = parseInt(mainContainer.dataset.currentPage);

  loadMoreButton.addEventListener('click', function(event) {
    // The trigger is a real link to /page/N/ (crawlable); JS enhances it to load inline
    event.preventDefault();

    // Prevent duplicate AJAX calls
    if (isLoading) return;

    isLoading = true;
    loadMoreButton.disabled = true;
    loadMoreButton.setAttribute('aria-disabled', 'true');
    loadMoreButton.classList.add('loading');
    loadMoreButton.setAttribute('aria-busy', 'true');

    const formData = new URLSearchParams({
      action: 'loadmore_posts',
      type: contentType,
      id: contentId,
      paged: currentPage,
      security: vz_ajax.loadmore_nonce,
    });

    fetch(vz_ajax.ajaxurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
      credentials: 'same-origin',
      signal: AbortSignal.timeout(8000)
    })
    .then(response => {
      // fetch only rejects on network errors, so a rejected nonce (403) would
      // otherwise be pasted into the post list as if it were markup.
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      return response.text();
    })
    .then(data => {
      if (!data) return;

      // Create temporary container to parse HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data;

      // Insert all children before the button
      while (tempDiv.firstChild) {
        loadMoreButton.parentNode.insertBefore(tempDiv.firstChild, loadMoreButton);
      }

      currentPage++;
      mainContainer.dataset.currentPage = currentPage;

      // Keep the fallback link pointing at the next uncached page
      if (loadMoreButton.tagName === 'A' && loadMoreButton.href) {
        loadMoreButton.href = loadMoreButton.href.replace(/\/page\/\d+\//, '/page/' + (currentPage + 1) + '/');
      }

      if (typeof vzLazyLoadUpdate === 'function') {
        vzLazyLoadUpdate();
      }
    })
    .catch(error => {
      console.error('Load more failed:', error);
    })
    .finally(() => {
      isLoading = false;
      loadMoreButton.classList.remove('loading');
      loadMoreButton.removeAttribute('aria-busy');

      if (currentPage >= maxPages) {
        loadMoreButton.remove();
      } else {
        loadMoreButton.disabled = false;
        loadMoreButton.removeAttribute('aria-disabled');
      }
    });
  });
}
